import { render, staticRenderFns } from "./PartnerLogo.vue?vue&type=template&id=026f1b6f"
import script from "./PartnerLogo.vue?vue&type=script&lang=js"
export * from "./PartnerLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports